import { isNumber } from './isNumber';
import { isString } from './isString';

export function castToNumber(input, altOutput = undefined) {
  const output = isString(input) ? Number(`${input}`.replace(/[^0-9.+-]/g, '')) : Number(input);
  return isNumber(output) ? output : altOutput;
}
